import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Evented.js";
import { HandleOwnerMixin as o } from "../../core/HandleOwner.js";
import { unwrapOr as r, destroyMaybe as i } from "../../core/maybe.js";
import { property as n } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import { DrawOperation as s } from "./DrawOperation.js";
import { SceneDrawSurface as p, ElevationDrawSurface as d } from "./drawSurfaces.js";
import { InteractiveToolBase as l } from "../interactive/InteractiveToolBase.js";

var h = /*#__PURE__*/function (_o) {
  _inherits(h, _o);

  var _super = _createSuper(h);

  function h(e) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this, e), _this.defaultZ = 0, _this.elevationInfo = null, _this.hasZ = !0, _this.mode = null, _this.snapToScene = null, _this.type = "draw-3d";
    return _this;
  }

  _createClass(h, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      var e = r(this.elevationInfo, {
        mode: this.hasZ ? "absolute-height" : "on-the-ground",
        offset: 0
      }),
          t = this.view;
      this.drawOperation = new s({
        view: t,
        manipulators: this.manipulators,
        geometryType: this.geometryType,
        drawingMode: this.mode,
        hasZ: this.hasZ,
        defaultZ: this.defaultZ,
        snapToSceneEnabled: this.snapToScene,
        drawSurface: "3d" === t.type ? new p(t, e) : null,
        elevationDrawSurface: "3d" === t.type ? new d(e, this.defaultZ, t) : null,
        hasM: !1,
        elevationInfo: e
      }), this.handles.add([this.drawOperation.on("vertex-add", function (e) {
        return _this2.onVertexAdd(e);
      }), this.drawOperation.on("vertex-remove", function (e) {
        return _this2.onVertexRemove(e);
      }), this.drawOperation.on("vertex-update", function (e) {
        return _this2.onVertexUpdate(e);
      }), this.drawOperation.on("cursor-update", function (e) {
        return _this2.onCursorUpdate(e);
      }), this.drawOperation.on("complete", function (e) {
        return _this2.onComplete(e);
      })]), this.complete();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.drawOperation = i(this.drawOperation), this._set("view", null);
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this.drawOperation.canRedo;
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this.drawOperation.canUndo;
    }
  }, {
    key: "enabled",
    set: function set(e) {
      this.drawOperation.interactive = e, this._set("enabled", e);
    }
  }, {
    key: "updating",
    get: function get() {
      var e, t;
      return null != (e = null == (t = this.drawOperation) ? void 0 : t.updating) && e;
    }
  }, {
    key: "completeCreateOperation",
    value: function completeCreateOperation() {
      this.drawOperation.complete();
    }
  }, {
    key: "onDeactivate",
    value: function onDeactivate() {
      this.drawOperation.isCompleted || this.drawOperation.cancel();
    }
  }, {
    key: "getVertexCoords",
    value: function getVertexCoords() {
      return this.drawOperation.vertices;
    }
  }, {
    key: "onInputEvent",
    value: function onInputEvent(e) {
      this.drawOperation.onInputEvent(e);
    }
  }, {
    key: "redo",
    value: function redo() {
      this.drawOperation.redo();
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "undo",
    value: function undo() {
      this.drawOperation.undo();
    }
  }, {
    key: "onComplete",
    value: function onComplete(e) {
      this.emit("complete", e);
    }
  }, {
    key: "onCursorUpdate",
    value: function onCursorUpdate(e) {
      this.emit("cursor-update", e);
    }
  }, {
    key: "onVertexAdd",
    value: function onVertexAdd(e) {
      this.emit("vertex-add", e);
    }
  }, {
    key: "onVertexRemove",
    value: function onVertexRemove(e) {
      this.emit("vertex-remove", e);
    }
  }, {
    key: "onVertexUpdate",
    value: function onVertexUpdate(e) {
      this.emit("vertex-update", e);
    }
  }]);

  return h;
}(o(t.EventedMixin(l)));

e([n({
  constructOnly: !0,
  nonNullable: !0
})], h.prototype, "defaultZ", void 0), e([n()], h.prototype, "drawOperation", void 0), e([n({
  constructOnly: !0
})], h.prototype, "elevationInfo", void 0), e([n({
  value: !0
})], h.prototype, "enabled", null), e([n({
  constructOnly: !0
})], h.prototype, "geometryType", void 0), e([n({
  constructOnly: !0
})], h.prototype, "hasZ", void 0), e([n({
  constructOnly: !0
})], h.prototype, "mode", void 0), e([n()], h.prototype, "snapToScene", void 0), e([n({
  readOnly: !0
})], h.prototype, "type", void 0), e([n({
  readOnly: !0
})], h.prototype, "updating", null), e([n({
  constructOnly: !0,
  nonNullable: !0
})], h.prototype, "view", void 0), h = e([a("esri.views.draw.DrawTool")], h);
export { h as DrawTool };